const getBrandsApi = () => `${process.env.REACT_APP_API_ENDPOINT}/api/v1/master/gocar-vehicle-brands/?category=mobil`

const getModelsApi = brand_id => `${process.env.REACT_APP_API_ENDPOINT}/api/v1/master/gocar-vehicle-models/?brand_id=${brand_id}&category=mobil`

const registerGocarSimple = () => `${process.env.REACT_APP_API_ENDPOINT}/api/v1/policy/create_gocar_simple_policy/`

const registerGocarComprehensive = () => `${process.env.REACT_APP_API_ENDPOINT}/api/v1/policy/create_gocar_complete_policy/`

const createQuotes = () => `${process.env.REACT_APP_API_ENDPOINT}/api/quote/create_gocar_quote/`

const imageUpload = () => `${process.env.REACT_APP_API_ENDPOINT}/api/quote/upload_gocar_quote_photo/`

export default {
    getBrandsApi,
    getModelsApi,
    registerGocarSimple,
    registerGocarComprehensive,
    createQuotes,
    imageUpload
}



// WEBPACK FOOTER //
// ./src/helpers/url.js